import { render } from "./keywordListDisplay.vue?vue&type=template&id=1a403af9"
import script from "./keywordListDisplay.vue?vue&type=script&lang=js"
export * from "./keywordListDisplay.vue?vue&type=script&lang=js"

import "./keywordListDisplay.vue?vue&type=style&index=0&id=1a403af9&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__